import SpinnerIcon from '@/assets/icons/SpinnerIcon';

import styles from './styles.module.css';

type SpinnerProps = {
  diameter?: number;
  color?: string;
};

export const Spinner = ({ diameter = 48, color = '--totem-color-secondary-500' }: SpinnerProps) => (
  <SpinnerIcon className={styles.spinnerIcon} width={diameter} height={diameter} color={color} />
);
